"use client";

import { motion } from "motion/react";
import Reveal from "../../enterprise/components/Reveal";
import { useTranslations } from "next-intl";

const HeroSection = () => {
  const t = useTranslations("governance");
  return (
    <section>
      <div className="-mt-[78px] flex h-screen items-end justify-end bg-[url('/images/backgrounds/hero-governance.png')] bg-cover bg-center bg-no-repeat max-lg:h-[800px] max-sm:h-[300px] max-sm:bg-[length:130%] max-sm:bg-left">
        <div className="mb-[145px] max-w-[670px] px-[78px] max-lg:hidden">
          <Reveal
            delay={0.1}
            duration={0.8}
            direction="left"
            withBlur={true}
            blurAmount={8}
          >
            <h1 className="text-[56px]/[64px] tracking-[-1px]">
              {t("governed-by-the-community-written-in-code")}
            </h1>
          </Reveal>
          {/* <motion.div
            initial={{ opacity: 0, translateY: 40 }}
            whileInView={{ opacity: 1, translateY: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="mt-16 flex gap-3">
              <button className="rounded-[8px] bg-[#06f] px-4 py-2 text-base font-medium text-white">
                {t("join-the-dao")}
              </button>
              <button className="rounded-[8px] border border-black/20 px-4 py-2 text-base font-medium text-[#202020]">
                {t("read-constitution")}
              </button>
              <button className="rounded-[8px] border border-black/20 px-4 py-2 text-base font-medium text-[#202020]">
                {t("submit-a-proposal")}
              </button>
            </div>
          </motion.div> */}
        </div>
      </div>
      {/* tablet -mobile */}
      <div className="mx-auto max-w-[670px] px-[78px] text-center max-lg:px-10 max-sm:px-4 lg:hidden">
        <Reveal
          delay={0.1}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <h1 className="mt-5 text-[56px]/[64px] tracking-[-1px] max-lg:text-[48px]/[56px] max-sm:mt-0 max-sm:text-[32px]/[40px]">
            {t("governed-by-the-community-written-in-code")}
          </h1>
        </Reveal>
        <Reveal
          delay={0.5}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <p className="mt-4 text-base text-[#646464]">
            {t("governed-by-the-community-written-in-code")}
          </p>
        </Reveal>
        {/* <motion.div
          initial={{ opacity: 0, translateY: 40 }}
          whileInView={{ opacity: 1, translateY: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <div className="mt-14 flex gap-3 max-sm:flex-col">
            <button className="rounded-[8px] bg-[#06f] px-4 py-2 text-base font-medium text-white">
              {t("join-the-dao")}
            </button>
            <button className="rounded-[8px] border border-black/20 px-4 py-2 text-base font-medium text-[#202020]">
              {t("read-constitution")}
            </button>
            <button className="rounded-[8px] border border-black/20 px-4 py-2 text-base font-medium text-[#202020]">
              {t("submit-a-proposal")}
            </button>
          </div>
        </motion.div> */}
      </div>
    </section>
  );
};

export default HeroSection;
